import { AppointmentMisschedulingReasonOptions } from 'core/appointments/domain/Appointment'

export const APPOINTMENT_MISSCHEDULING_REASON_OPTIONS = [
  {
    value: AppointmentMisschedulingReasonOptions.FirstAvailable,
    label: 'First Available Appointment',
  },
  {
    value: AppointmentMisschedulingReasonOptions.InsuficcientLeadTime,
    label: 'Insufficient Lead Time',
  },
  {
    value: AppointmentMisschedulingReasonOptions.TrafficOrWeatherDelays,
    label: 'Traffic or Weather Delays',
  },
  {
    value: AppointmentMisschedulingReasonOptions.Other,
    label: 'Other',
  },
]
